import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-427684d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = {
  key: 1,
  class: "content-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "download-icon-black",
  disabled: ""
}
const _hoisted_5 = {
  key: 1,
  class: "download-icon"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "delete-icon" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed, watch, ref } from "vue";
import Popup from "./Popup.vue";
import Table from "@/components/TablePersistentChecking.vue";
import { downloadManager, streamDownloadFile } from "@/services/network";
import IFileDownloadList from "@/Interfaces/FileDownloadQueue/IFileDownloadList";
import { DisplayableKeys } from "@/services/SorterService";
import  DownloadIcon from './svg/DownloadIcon.vue'
import  DeleteIcon from './svg/DeleteIcon.vue'
import { authService } from "@/auth/authSingleton";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import Spinner from './Spinner.vue';
import DownloadIconBlack from "./svg/DownloadIconBlack.vue";
import { StreamDownloadState } from "@/services/network/StreamDownloadState";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileDownloadPopUp',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const PopUpOpen = computed<boolean>({
    get() {
        return props.modelValue ?? false; 
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const userEmail = computed(() => {
    return authService.getEmailAddress();
});
const working = ref (false)
const deletingInProgress= ref (false)
const DowloadQueueRows = ref <IFileDownloadList[]>([]);
const cols: DisplayableKeys <IFileDownloadList>[]  = [
    'FileType',
    'DatetimeRequested',
    'FileName',
    'FileStatus',
    'DatetimeCompleted',
    'FileStatus',
    'FileStatus'
];
const labels: string[] = [
    "File Type",
    "Date Time Requested",
    "File Name",
    "Status",
    "Date Time Completed",
    "", 
    ""
];
watch(PopUpOpen, async (newValue) => {
    if (newValue) {
        await getDownloadQueue()
    }
});
function closeChild() {
    PopUpOpen.value = false;
    DowloadQueueRows.value = [];
}
async function getDownloadQueue(){
    if (working.value) return;
    working.value = true;
    try{
        const res = (await downloadManager.get({userName: userEmail.value})).data.map(x => ({...x, Downloading : false} ));
        DowloadQueueRows.value = res
    }catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: 'File Download Queue List',
            error
        });
        DowloadQueueRows.value = [];
    } finally {
        working.value = false;
    }    
}
async function deleteFileFromTheQueue(fileId: number){
    if(deletingInProgress.value) return
    try{
        deletingInProgress.value = true
        await downloadManager.delete(undefined, { fileId: fileId });
        await getDownloadQueue()
        useNotifierWithErrFormatter().success({msg: "The file was succesfully deleted"});
    }catch (error){
        useNotifierWithErrFormatter().error({errorType: "File Downlaod", error});
    }finally {
        deletingInProgress.value = false
    }  
}
async function downloadFile(value: IFileDownloadList){
    const result = await streamDownloadFile.streamDownload({fileId:value.FileId.toString()})
    console.log("result: " +  StreamDownloadState[result])
    if (result === StreamDownloadState.FAILURE || result === StreamDownloadState.REDIRECT ) {
        value.Downloading = false;
        if(result === StreamDownloadState.REDIRECT ){
            window.location.reload();
        }
    }
    else{
        value.Downloading = true;
    }
}
function toTitleCase(str) {
  return str.replace(/\w\S*/g, text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!PopUpOpen.value,
    "onUpdate:modelValue": closeChild,
    title: "File Download",
    hasClose: ""
  }, _createSlots({ _: 2 }, [
    (PopUpOpen.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (working.value || deletingInProgress.value)
                ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", { class: "link-btn" }, [
                      _createElementVNode("a", { onClick: getDownloadQueue }, "⟳ Refresh")
                    ]),
                    _createVNode(Table, {
                      Rows: DowloadQueueRows.value,
                      Cols: cols,
                      Labels: labels,
                      RowsPerPage: 20,
                      SplitColKeys: ""
                    }, {
                      DatetimeRequested: _withCtx(({value}) => [
                        _createTextVNode(_toDisplayString(value.DatetimeRequested.replaceAll("T", " ")), 1)
                      ]),
                      DatetimeCompleted: _withCtx(({value}) => [
                        _createTextVNode(_toDisplayString(value.DatetimeCompleted?.replaceAll("T", " ")), 1)
                      ]),
                      FileStatus: _withCtx(({value}) => [
                        _createTextVNode(_toDisplayString(toTitleCase(value.FileStatus)), 1)
                      ]),
                      "FileStatus-1": _withCtx(({ value }) => [
                        (value.FileStatus == 'COMPLETED')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (value.Downloading == true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(DownloadIconBlack)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(DownloadIcon, {
                                      onClick: ($event: any) => (downloadFile(value))
                                    }, null, 8, ["onClick"])
                                  ]))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_6))
                      ]),
                      "FileStatus-2": _withCtx(({ value }) => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(DeleteIcon, {
                            onClick: ($event: any) => (deleteFileFromTheQueue(value.FileId))
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["Rows"]),
                    _hoisted_8
                  ]))
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})